const baseUrl = "https://hwwebappreactdev.blob.core.windows.net/resources/";

export const confirmation = `${baseUrl}confirmation.wav`;
export const error = `${baseUrl}error.wav`;
export const login = `${baseUrl}login.wav`;
export const logout = `${baseUrl}logout.wav`;
export const success = `${baseUrl}success.wav`;
